// extracted by mini-css-extract-plugin
export var breadcrumb = "_1k-0";
export var breadcrumbArrow = "_1k-1";